import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '../abstract-field/abstract-field';
import 'vue-select/dist/vue-select.css';

import { Booking } from '@bookings/interfaces/booking';

import BookingTable from '@bookings/components/tables/booking-table/booking-table.vue';
import { BPCDisplayConfigField } from '@core/interfaces/bpc-display-config';

@Component({
  name: 'bpc-booking-table-input',
  components: {
    'bpc-booking-table': BookingTable,
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class BookingTableInput extends mixins(AbstractField) {
  $refs: {
    bookingEventTable: InstanceType<typeof BookingTable> & {
      fields: BPCDisplayConfigField[];
    };
  };

  @Prop(Array) readonly value: any[];

  @Prop({ type: String, default: 'drawer' }) readonly type: string;
  @Prop(String) readonly selectEntity: string;

  @Prop(Array) readonly filters: any[];
  @Prop(String) readonly fieldForStorage: string;

  @Prop(Boolean) readonly withDraft: boolean;
  @Prop({ type: String, default: 'default-without-activity-group' })
  readonly createFormConfigName: string;
  @Prop({ type: String, default: 'default-edit-without-activity-group' })
  readonly editFormConfigName: string;

  @Prop({
    type: Array,
    default: () => ['configLoaded', 'paginationLoaded', 'orderLoaded'],
  })
  readonly customFlagsToCheckBeforeLoadEntities: Array<any>;
  @Prop({ type: String, default: 'table-input' }) readonly displayConfigName: string;

  get model(): any[] {
    return this.value;
  }
  set model(val: any[]) {
    this.$emit('input', val);
    if (this.eventsConfig && this.eventsConfig.emit) {
      this.eventsConfig.emit.forEach(event => {
        this.$root.$emit(event, val);
      });
    }
  }

  // TO-DO: Make this generic for every field
  get activityGroupId(): number {
    const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
    if (filter['value']) {
      return Number(filter['value']);
    } else {
      return null;
    }
  }

  public entity: Booking = null;
  public entityName = 'booking';
  public pluralEntityName = 'bookings';
  public permissionEntityNameToUse = 'bookings';

  onChange($event) {
    this.$emit('change', $event);
  }

  // TODO: Determine if model has ID or not to consume api or create in localstorage.
  get mode(): string {
    if (this.activityGroupId) {
      return 'api';
    } else {
      return 'storage';
    }
  }

  // onFormSave() {
  //   console.log('Saving');
  //   const filter = this.filters.find(filter => filter['filterField'] == this.fieldForStorage);
  //   if (filter['value']) {
  //     this.$refs.stdForm.formModel[filter['filterField']] = filter['value'];
  //   }
  //   this.$refs.stdForm.saveEntity();
  // }

  // onNew() {
  //   this.entity = null;
  //   this.showForm = true;
  //   if (this.type === 'drawer') {
  //     // this.$bvModal.show('modal-resource-form');
  //     this.showDrawerSection = true;
  //   } else if (this.type === 'modal') {
  //     this.$bvModal.show(`${this.selectEntity}-entity-table-input-modal`);
  //   }
  // }

  // onEdit(e) {
  //   console.log('clickOnEdit', e);
  //   this.entity = e.item;
  //   this.showForm = true;
  //   if (this.type === 'drawer') {
  //     this.showDrawerSection = true;
  //   } else if (this.type === 'modal') {
  //     this.$bvModal.show(`${this.selectEntity}-entity-table-input-modal`);
  //   }
  // }

  // onFormClose() {
  //   this.showForm = false;
  //   if (this.type === 'drawer') {
  //     this.showDrawerSection = false;
  //   } else if (this.type === 'modal') {
  //     this.$bvModal.hide(`${this.selectEntity}-entity-table-input-modal`);
  //   }
  //   this.showDrawerSection = false;
  // }

  // @Watch('value')
  // updateItemsProvider() {
  //   this.$refs.provider.items = this.value;
  //   if (this.value) {
  //     this.$bpcStorage.set(this.selectPluralEntity, this.value);
  //     this.updateRowsActions();
  //   }
  //   console.log('change items provider');
  // }
}
